<template>
  <div class="country-admin section">
    <h1 class="title">Countries</h1>
    <div>
      <div class="media" v-for="country in countries">
        <div class="media-left">
          <img v-bind:src="'/static/img/flags/'+country.en.name.replace(' ', '-')+'.png'" />
        </div>
        <h2 class="subtitle">{{country.en.name}}</h2>
        {{country |json}}
      </div>
    </div>
  </div>
</template>

<script>
import fb from 'firebase'
import countries from '../lib/countries'
import _ from 'underscore'

export default {
  data: function() {
    return {
      countries: []
    }
  },
  ready: function() {
    window.fb = fb
    window.countryList = countries
    window._ = _

    self = this
    fb.database().ref('countries').on('child_added', function(snapshot) {
      let country = snapshot.val()
      country.key = snapshot.key
      self.countries.push(country)
    })

  }
}
</script>



/** WEBPACK FOOTER **
 ** Countries.vue?32507b30
 **/